<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { orderBy } from "lodash";
import PrintOptions from "@/components/modals/print-options.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";

export default {
    page: {
        title: "Faculties",
    },
    components: {
        Layout,
        PageHeader,
        PrintOptions,
        AttachmentModal
    },
    data() {
        return {
            title: "Faculties",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Faculties",
                    active: true,
                },
            ],
            tableData: [],
            engagements: [
                {
                    id: 1,
                    value: "A",
                    name: "Pursuing advanced research degree program (Ph.D.)",
                    valueName: 'A - Pursuing advanced research degree program (Ph.D.)',
                },
                {
                    id: 2,
                    value: "B",
                    name: "Actively pursuing research 1 withing the last (3) years",
                    valueName: 'B - Actively pursuing research 1 withing the last (3) years',
                },
                {
                    id: 3,
                    value: "C",
                    name: "Producing technologies for commercialization or livelihood improvement",
                    valueName: 'C - Producing technologies for commercialization or livelihood improvement',
                },
                {
                    id: 4,
                    value: "D",
                    name: "Research work resulted in an extension program",
                    valueName: 'D - Research work resulted in an extension program',
                },
                {
                    id: 5,
                    value: "E",
                    name: "None of the above",
                    valueName: 'E - None of the above',
                },
            ],
            fields: [
                {
                    key: "faculty",
                    sortable: true,
                    label: "Faculty",
                },
                {
                    key: "engagement",
                    sortable: true,
                },
            ],
            engagement: null,
            deliveryUnit: null,
            indexSelected: null,
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            sortDesc: false,
            tableBusy: false,
            filter: null,
            filterOn: [],
            sortBy: "",
            modalTitle: "",
            showFilter: false,
            campusSelect: 0,
            duSelect: null,
            campuses: [],
            dus: [],
            filterEmploymentType: 'All',
        };
    },
    computed: {
        rows() {
            let data = this.tableData;
            if(this.filterEmploymentType.toLowerCase() !== 'all'){
                data = data.filter((item) => {return item.employmentType.toLowerCase().includes(this.filterEmploymentType.toLowerCase())});
            }
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        filteredEmploymentType(){
            let data = this.tableData;
            if(this.filterEmploymentType.toLowerCase() !== 'all'){
                data = data.filter((item) => {
                    return item.employmentType.toLowerCase().includes(this.filterEmploymentType.toLowerCase());
                });
            }
            return data;
        }
    },
    async created() {
        this.pageLoader(true);
        await this.getCampuses();
        await this.filteredDU(0);
        this.pageLoader(false);
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async getCampuses() {
            let data = this.$store.state.decrypt.campusAccessList();
            data.forEach((item) => {
                item.noSpaces = item.CampusName.replace(/\s/g, "");
            });
            this.campuses = data;
        },
        async searchFaculty(id) {
            this.tableBusy = true;
            await this.$store
                .dispatch("faculty/GetFacultyByDU", id)
                .then((response) => {
                    response.data.forEach((item) => {
                        let middleName = item.accountableOfficer.middleName
                            ? item.accountableOfficer.middleName
                            : "";
                        item.fullName =
                            item.accountableOfficer.lastName +
                            ", " +
                            item.accountableOfficer.firstName +
                            " " +
                            middleName;
                        let findEngagement = this.engagements.find(
                            (x) => x.value === item.facultyEngagement
                        );
                        item.engagement = findEngagement ? findEngagement.name : '';
                        item.employmentType = item.accountableOfficer.employmentType.toLowerCase() === 'permanent' ? 'Permanent' : 'Part Time';
                        item.filterKey = `${item.accountableOfficer.lastName.trim()} ${item.accountableOfficer.firstName.trim()} `
                    });
                    this.tableData = response.data;
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting delivery units",
                        "error"
                    );
                });
            this.tableBusy = false;
        },
        async filteredDU(id) {
            this.dus = [];
            this.duSelect = null;
            if(id == 0){
                this.tableBusy = true;
                await this.$store
                    .dispatch("faculty/GetAllFaculties")
                    .then((response) => {
                        response.data.forEach((item) => {
                            let middleName = item.accountableOfficer.middleName
                                ? item.accountableOfficer.middleName
                                : "";
                            item.fullName =
                                item.accountableOfficer.lastName.trim() +
                                ", " +
                                item.accountableOfficer.firstName.trim() +
                                " " +
                                middleName;
                            let findEngagement = this.engagements.find(
                                (x) => x.value === item.facultyEngagement
                            );
                            item.engagement = findEngagement ? findEngagement.name : '';
                            item.employmentType = item.accountableOfficer.employmentType.toLowerCase() === 'permanent' ? 'Permanent' : 'Part Time';
                            item.filterKey = `${item.accountableOfficer.lastName.trim()} ${item.accountableOfficer.firstName.trim()} `
                        });
                        this.tableData = orderBy(response.data, ['fullName'], ['asc']);
                    })
                    .catch((error) => {
                        this.showToast(
                            "Something went wrong - getting delivery units",
                            "error"
                        );
                    });
                    this.tableBusy = false;
            }else{
                await this.$store
                    .dispatch("deliveryunit/GetDeliveryUnitByCampus", id)
                    .then((response) => {
                        this.dus = response.data;
                    })
                    .catch((error) => {
                        this.showToast(
                            "Something went wrong - getting delivery units",
                            "error"
                        );
                    });
            }
            
        },
        printSystemReport(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/Bar1/AdvanceEd/Faculty/Output/System",
                routeVariables: [],
            });
            this.$bvModal.show("print-options-modal");
        },
        printCampusReport(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/Bar1/AdvanceEd/Faculty/Output/Campus",
                routeVariables: [this.$store.state.data.selectedCampus.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        getAttachments(id){
            this.$refs.attachmentModal.setUploadOpt({
                type: `Faculty`,
                placement: "left",
                folder: "Planning",
            });
            this.$refs.attachmentModal.getData(id);
            this.$bvModal.show("upload-attachment-modal");
        }
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="card border">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <h4 class="card-title m-0 text-nowrap me-2">
                            Faculty List
                        </h4>
                        <button
                            class="btn rounded-pill me-2"
                            :class="{
                                'btn-light': filterEmploymentType !== 'All',
                                'btn-warning': filterEmploymentType === 'All',
                            }"
                            type="button"
                            @click="filterEmploymentType = 'All'"
                        >
                            <span class="px-3">All</span>
                        </button>
                        <button
                            class="btn rounded-pill me-2"
                            :class="{
                                'btn-light': filterEmploymentType !== 'Permanent',
                                'btn-warning': filterEmploymentType === 'Permanent',
                            }"
                            type="button"
                            @click="filterEmploymentType = 'Permanent'"
                        >
                            <span class="px-3">Permanent</span>
                        </button>
                        <button
                            class="btn rounded-pill"
                            :class="{
                                'btn-light': filterEmploymentType !== 'Part Time',
                                'btn-warning': filterEmploymentType === 'Part Time',
                            }"
                            type="button"
                            @click="filterEmploymentType = 'Part Time'"
                        >
                            <span class="px-3">Part Time</span>
                        </button>
                    </div>
                    <div class="col-md-6 text-right">
                        <div class="d-flex align-items-center float-end">
                            <b-dropdown
                                id="dropdown-dropleft"
                                right
                                variant="purple btn-sm me-3"
                                toggle-class="text-decoration-none"
                                menu-class="dropdown-menu-end"
                                no-caret
                            >
                                <template #button-content>
                                    <i class="bx bx-printer me-1"></i> Reports
                                </template>
                                <b-dropdown-item @click="printSystemReport()">
                                    System
                                </b-dropdown-item>
                                <b-dropdown-item @click="printCampusReport()">
                                    {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                                </b-dropdown-item>
                            </b-dropdown>
                            <a
                                href="javascript:void(0);"
                                class="me-4 text-white"
                                @click="showFilter = !showFilter"
                                id="filter-faculty"
                                ><b class="d-flex align-items-center"
                                    ><i class="bx bx-filter font-size-18"></i
                                    >Show Filters</b
                                ></a
                            >
                            <b-popover
                                :target="`filter-faculty`"
                                triggers="click blur"
                                placement="left"
                                :show.sync="showFilter"
                                custom-class="popover-supplier"
                            >
                                <template v-slot:title>
                                    <div
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-between
                                        "
                                    >
                                        <small>Filters</small>
                                        <span
                                            class="
                                                bx bx-x
                                                font-size-14
                                                cursor-pointer
                                            "
                                            @click="showFilter = false"
                                        ></span>
                                    </div>
                                </template>
                                <div class="mb-2">
                                    <label for="campusSelect"
                                        >Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</label
                                    >
                                    <b-form-select
                                        id="campusSelect"
                                        class="form-select"
                                        v-model="campusSelect"
                                        size="sm"
                                        @change="filteredDU"
                                    >
                                        <option value="0">All</option>
                                        <option
                                            v-for="x in campuses"
                                            :key="x.Id"
                                            :value="x.Id"
                                        >
                                            {{ x.CampusName }}
                                        </option>
                                    </b-form-select>
                                </div>
                                <div class="mb-2" v-if="campusSelect > 0">
                                    <label for="duSelect"
                                        >Select Delivery Unit</label
                                    >
                                    <b-form-select
                                        id="duSelect"
                                        class="form-select"
                                        v-model="duSelect"
                                        size="sm"
                                        @change="searchFaculty"
                                    >
                                        <option
                                            v-for="x in dus"
                                            :key="x.id"
                                            :value="x.id"
                                        >
                                            {{ x.name }}
                                        </option>
                                    </b-form-select>
                                </div>
                            </b-popover>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_length"
                            class="dataTables_length"
                        >
                            <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select
                                    class="form-select form-select-sm"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;entries
                            </label>
                            <button v-if="duSelect" type="button" class="btn btn-success btn-sm ms-3" @click="getAttachments(duSelect)"><i class="bx bx-paperclip me-1"></i> Attachments</button>
                        </div>
                        
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                            <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search..."
                                    class="form-control form-control-sm ms-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="filteredEmploymentType"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :busy="tableBusy"
                        @filtered="onFiltered"
                        bordered
                        outlined
                        hover
                        striped
                        show-empty
                    >
                        <template #empty="scope">
                            <div class="text-center">
                                {{ scope.emptyText }}
                            </div>
                        </template>
                        <template #table-busy>
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div
                                            class="spinner-chase w-20px h-20px"
                                        >
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template #cell(faculty)="row">
                            <div class="d-flex align-items-center">
                                <div class="avatar-sm me-2">
                                    <span
                                        class="
                                            avatar-title
                                            rounded-circle
                                            bg-soft bg-primary
                                            text-primary
                                            font-size-16
                                        "
                                        >{{
                                            row.item.accountableOfficer.firstName
                                                .charAt(0)
                                                .toUpperCase()
                                        }}{{
                                            row.item.accountableOfficer.lastName
                                                .charAt(0)
                                                .toUpperCase()
                                        }}</span
                                    >
                                </div>
                                <div>
                                    <div class="mt-1">
                                        <h5 class="mb-0">
                                            {{
                                                row.item.accountableOfficer.lastName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.accountableOfficer.lastName.slice(
                                                    1
                                                )
                                            }},
                                            {{
                                                row.item.accountableOfficer.firstName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.accountableOfficer.firstName.slice(
                                                    1
                                                )
                                            }}
                                            {{
                                                row.item.accountableOfficer
                                                    .middleName
                                                    ? `${row.item.accountableOfficer.middleName
                                                          .charAt(0)
                                                          .toUpperCase()}.`
                                                    : ""
                                            }}
                                        </h5>
                                    </div>
                                    <div>
                                        {{
                                            row.item.accountableOfficer.position
                                        }}
                                    </div>
                                    <i>{{
                                        row.item.accountableOfficer.idNo
                                    }}</i>
                                </div>
                            </div>
                        </template>
                        <template #cell(engagement)="row">
                            {{row.value ? row.value : 'Not assigned yet.'}}
                        </template>
                    </b-table>
                </div>
                <div class="row">
                    <div class="col">
                        <div
                            class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            "
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <print-options ref="printOpt"></print-options>
        <attachment-modal
            :wActions="false"
            title="Faculty Attachment"
            ref="attachmentModal"
        ></attachment-modal>
    </Layout>
</template>